import React from "react";

const StaticMenu = () => {
  return (
    <div className="flex justify-between items-center text-navy font-display font-semi space-x-3 p-5 text-xl md:w-2/3 md:text-2xl md:pb-3 animate-fadein">
      <a href="/projects">Featured</a>
      <a href="/in-progress">In Progress</a>
       <a href="/future-work">Future Work</a>
      <a href="/portfolio">Completed</a>
    </div>
  );
};

export default StaticMenu;
